import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";

import { Icon } from "@cobasi/ds-icons";
import { chevronDown, bars, times } from "@cobasi/ds-icons/regular";

import MediaMatch from "@/components/shared/MediaMatch";

import styles from "./styles.module.scss";

const Header: React.FC = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;

    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    function handleEsc(event: KeyboardEvent) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [open]);

  return (
    <header className={styles.header}>
      <div className={styles["header--container"]}>
        <Link className={styles.logoWrapper} href="/">
          <img
            src="https://objectstorage.sa-vinhedo-1.oraclecloud.com/n/axuh3s32sabm/b/cobasi-institutional-cms-bucket/o/prod/pet-anjo-logo.svg"
            alt="Logo Pet Anjo"
            className={styles.logo}
          />
        </Link>

        <div className={styles.menuWrapper} ref={menuRef}>
          <div>
            <MediaMatch greaterThan="medium">
              <button
                type="button"
                className={styles["menu--button"]}
                onClick={() => setOpen((prev) => !prev)}
                aria-expanded={open}
              >
                <h2 className="subtitle-lg">Conheça mais</h2>
                <span
                  className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
                  aria-hidden="true"
                >
                  <Icon fontSize={18} icon={chevronDown} />
                </span>
              </button>
            </MediaMatch>

            <MediaMatch lessThan="medium">
              <button
                type="button"
                className={styles["menu--hamburger"]}
                onClick={() => setOpen((prev) => !prev)}
                aria-label="Abrir menu"
                aria-expanded={open}
              >
                <Icon fontSize={18} icon={open ? times : bars} />
              </button>
            </MediaMatch>
          </div>

          <ul
            className={`${styles.menu_list} ${open ? styles.menu_listOpen : ""}`}
            aria-hidden={!open}
          >
            <li className="subtitle-md">
              <Link href="https://www.cobasi.com.br/lojas" target="_black">
                Unidades Pet Anjo
              </Link>
            </li>

            <li className="subtitle-md">
              <Link
                href="https://atendimentopetanjo.zendesk.com/hc/pt-br/requests/new"
                target="_black"
              >
                Fale conosco
              </Link>
            </li>

            <li className="subtitle-md">
              <Link
                href="https://atendimentopetanjo.zendesk.com/hc/pt-br/"
                target="_black"
              >
                Central de ajuda
              </Link>
            </li>

            <li className="subtitle-md">
              <Link href="https://petanjo.com/blog/" target="_black">
                Blog
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
